import { render, staticRenderFns } from "./TheHero.vue?vue&type=template&id=44039bdc&scoped=true"
import script from "./TheHero.vue?vue&type=script&lang=js"
export * from "./TheHero.vue?vue&type=script&lang=js"
import style0 from "./TheHero.vue?vue&type=style&index=0&id=44039bdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44039bdc",
  null
  
)

export default component.exports